class exports.Contracts_Delete_Dialog_Handler extends DialogHandler
    init: () ->
        @layoutUrl = 'backend/portal/contracts/load-layout-delete'
        @saveUrl = 'backend/portal/contracts/delete-contract'
        @classes = 'small_dialog'
        @successAction = @refreshContracts
        @createDialog()

    afterLoadLayout: () ->
        ths = this
        @openDialog()

        @dialog.find('.save-btn').bind 'click', () =>
            @save('Deleting Contract')

    refreshContracts: () ->
        @parent.parent.unloadContract()
